import React from 'react';
import { Camera, Video, X } from 'lucide-react';


export default function DeliveryMediaCapture({
  photos,
  video,
  photoInputRef,
  videoInputRef,
  handlePhotoCapture,
  handleVideoCapture,
  removePhoto,
  handleUseOriginalPhoto,
  removeVideo,
}) {
  return (
    <>
      <div className="space-y-2">
        <label className="text-sm font-medium text-stone-700">Photos</label>
        <div className="flex flex-wrap gap-2">
          {photos.map((photo, index) => (
            <div key={photo.preview} className="relative w-20 h-20">
              <img src={photo.preview} alt="Delivery proof" className="w-full h-full object-cover rounded-lg" />
              <button
                type="button"
                onClick={() => removePhoto(index)}
                className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center"
                aria-label={`Remove delivery photo ${index + 1}`}
              >
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => photoInputRef.current?.click()}
            className="w-20 h-20 border-2 border-dashed border-stone-300 rounded-lg flex flex-col items-center justify-center text-stone-400 hover:border-stone-400 hover:text-stone-500 transition-colors"
            data-testid="add-photo-btn"
          >
            <Camera className="h-6 w-6" />
            <span className="text-xs mt-1">Add</span>
          </button>
          <input
            ref={photoInputRef}
            type="file"
            accept="image/*"
            multiple
            onChange={handlePhotoCapture}
            className="hidden"
          />
        </div>
        {photos.map((photo, index) => photo.preparationError && <div key={index} className="text-sm text-amber-800" role="status">
          <p>Photo {index + 1}: {photo.preparationError}</p>
          {handleUseOriginalPhoto && (photo.useOriginal
            ? <p>Original selected. It may upload more slowly and remains subject to server validation.</p>
            : <button type="button" className="underline" onClick={() => handleUseOriginalPhoto(index)}>Use original for photo {index + 1}</button>)}
        </div>)}
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-stone-700">Video (optional, max 60s)</label>
        {video ? (
          <div className="relative w-32 h-24">
            <video src={video.preview} className="w-full h-full object-cover rounded-lg" />
            <button
              type="button"
              onClick={removeVideo}
              className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center"
              aria-label="Remove delivery video"
            >
              <X className="h-3 w-3" />
            </button>
            <div className="absolute bottom-1 left-1 bg-black/60 text-white text-xs px-1 rounded">Video</div>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => videoInputRef.current?.click()}
            className="flex items-center gap-2 px-4 py-2 border border-stone-300 rounded-lg text-stone-600 hover:bg-stone-50 transition-colors"
            data-testid="add-video-btn"
          >
            <Video className="h-4 w-4" />
            <span className="text-sm">Add Video</span>
          </button>
        )}
        <input
          ref={videoInputRef}
          type="file"
          accept="video/*"
          onChange={handleVideoCapture}
          className="hidden"
        />
      </div>
    </>
  );
}
